import React, {useMemo} from 'react';
import type {
  CheckboxListProps} from 'src/design/atoms/CheckboxList';
import {
  CheckboxList
} from 'src/design/atoms/CheckboxList';
import {useGetUserGroupSelectOptionsQuery} from 'src/redux/queries/userGroup';
import type {IListItem} from 'src/types/Form';

export interface UserGroupCheckboxListProps
  extends Omit<CheckboxListProps, 'values'> {
  showNotificationsGroups?: boolean;
  showPermissionsGroups?: boolean;
}
export const UserGroupCheckboxList: React.FC<UserGroupCheckboxListProps> = ({
  showNotificationsGroups,
  showPermissionsGroups,
  ...other
}) => {
  const {
    data: userGroup,
    isFetching,
    isLoading,
  } = useGetUserGroupSelectOptionsQuery({
    start: 0,
    length: 10000,
    active: true,
    showPermissionGroups: showPermissionsGroups,
    showNotificationGroups: showNotificationsGroups,
  });

  const values = useMemo(
    () =>
      userGroup?.data?.map(i => {
        return {
          value: String(i.id),
          label: i.label ?? 'Unknown Name',
        } as IListItem;
      }) ?? [],
    [userGroup?.data]
  );

  return (
    <CheckboxList
      {...other}
      disabled={isLoading || isFetching || other.disabled}
      values={values}
    />
  );
};
